import React, { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

import patchLocalizationValues from '../lib/patchLocalizationValues'

export default function Text({ code, values }: Props) {
    const memoValues = useMemo(() => patchLocalizationValues(values), [values])
    return <FormattedMessage id={code} values={memoValues} />
}

export type Props = {
    code: string
    values?: Record<string, unknown>
}
